import DocumentSetPreviewSlideIn from './DocumentSetPreviewSlideIn';

export default DocumentSetPreviewSlideIn;
